import { useContext, useState } from "react";
import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import Notificationicon from "../../../assets/svg/notifications.svg";
import Notification from "../../../components/Notification";
import help from "../../../assets/svg/help.svg";
import SidebarContext from "../../../context/SidebarContext";
import QR from "../../../assets/images/qrImage.png";
import CheckIcon from "@mui/icons-material/Check";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import QrCodeIcon from "@mui/icons-material/QrCode";
import StoreMallDirectoryIcon from "@mui/icons-material/StoreMallDirectory";
import UPS from "../../../assets/images/upsimage.png";
import Payment from "./Payment";

const paymentOptions = [
  {
    id: "credit",
    title: "Credit Card",
    icon: CreditCardIcon,
    description:
      "We partner with Stripe for secure, compliant payments. Your credit information is never stored on our app, ensuring safety and privacy.",
  },
  {
    id: "qr",
    title: "QR Code Payment",
    qrImage: QR,
    icon: QrCodeIcon,
    description: "Scan with your mobile payment app",
  },
  {
    id: "store",
    title: "Pay at Store",
    subTitle: "Enter Confirmation code",
    icon: StoreMallDirectoryIcon,
    description: "Visit any of our store locations to complete your payment",
  },
];

function CompleteYourPayment() {
  const { open } = useContext(SidebarContext);
  const [notificationDrawerOpen, setNotificationDrawerOpen] = useState(false);
  const [selectedId, setSelectedId] = useState("credit");
  const [paymentToggal, setPaymentToggal] = useState(false);

  const breadcrumbs = [
    <Link
      key="1"
      to="/"
      style={{ color: "#1C2630", fontWeight: 500, fontSize: "12px" }}
    >
      Home
    </Link>,
    <Link
      key="2"
      to="/shipping/route-partner"
      style={{ color: "#1C2630", fontWeight: 500, fontSize: "12px" }}
    >
      Shipping Service
    </Link>,
    <Link
      key="3"
      to="/shipping/get-shipping-quote"
      style={{ color: "#1C2630", fontWeight: 500, fontSize: "12px" }}
    >
      Get Shipping Quote
    </Link>,
    <Link
      key="3"
      to="/shipping/get-shipping-quote/result"
      style={{ color: "#1C2630", fontWeight: 500, fontSize: "12px" }}
    >
      Result
    </Link>,
    <Typography
      key="4"
      sx={{ color: "#959BA1", fontWeight: 500, fontSize: "12px" }}
    >
      Complete Your Payment
    </Typography>,
  ];

  const toggleNotification = () => {
    setNotificationDrawerOpen(!notificationDrawerOpen);
  };
  return (
    <>
      {paymentToggal ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: { xs: "auto", sm: "96vh" },
            minHeight: { xs: "100vh", sm: "96vh" },
            overflowY: "auto",
            margin: { xs: "10px", sm: "15px", md: "20px" },
            marginRight: { xs: "10px", sm: "15px", md: "0px" },
            width: {
              xs: "calc(100vw - 20px)",
              sm: open === true ? "calc(98vw - 240px)" : "calc(98vw - 80px)",
            },
            backgroundColor: "#FFF",
            padding: { xs: "15px", sm: "20px" },
            border: "2px solid #E5E5E8",
            borderRadius: "12px",
          }}
        >
          <Payment
            setPaymentToggal={setPaymentToggal}
            paymentToggal={paymentToggal}
          />
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: { xs: "auto", sm: "96vh" },
            minHeight: { xs: "100vh", sm: "96vh" },
            overflowY: "auto",
            margin: { xs: "10px", sm: "15px", md: "20px" },
            marginRight: { xs: "10px", sm: "15px", md: "0px" },
            width: {
              xs: "calc(100vw - 20px)",
              sm: open === true ? "calc(98vw - 240px)" : "calc(98vw - 80px)",
            },
            backgroundColor: "#FFF",
            padding: { xs: "15px", sm: "20px" },
            border: "2px solid #E5E5E8",
            borderRadius: "12px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "flex-start", sm: "center" },
              justifyContent: "space-between",
              borderBottom: "1px solid #E5E5E8",
              paddingBottom: "8px",
              gap: { xs: 2, sm: 0 },
            }}
          >
            <Box sx={{ width: { xs: "100%", sm: "auto" } }}>
              <Typography
                sx={{
                  fontSize: { xs: "20px", sm: "24px", md: "26px" },
                  fontWeight: "bold",
                }}
              >
                Complete Your Payment
              </Typography>
              <Breadcrumbs
                separator="›"
                aria-label="breadcrumb"
                sx={{
                  "& .MuiBreadcrumbs-ol": {
                    flexWrap: { xs: "wrap", sm: "nowrap" },
                  },
                }}
              >
                {breadcrumbs}
              </Breadcrumbs>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: { xs: "flex-start", sm: "flex-end" },
                gap: { xs: 1, sm: 0 },
              }}
            >
              <Box
                sx={{
                  marginRight: { xs: "10px", sm: "20px" },
                  cursor: "pointer",
                }}
                onClick={toggleNotification}
              >
                <img src={Notificationicon} alt="notification_icon" />
              </Box>
              <Notification
                open={notificationDrawerOpen}
                onClose={toggleNotification}
              />
              <Box>
                <img src={help} alt="help_icon" />
              </Box>
            </Box>
          </Box>

          <Box sx={{ display: "flex", mt: { xs: 2, sm: 4 } }}>
            <Grid container spacing={{ xs: 2, sm: 4 }}>
              {/* Left Section */}
              <Grid
                item
                xs={12}
                md={8}
                sx={{
                  borderRight: { xs: "none", md: "2px solid #E5E5E8" },
                  borderBottom: { xs: "2px solid #E5E5E8", md: "none" },
                  paddingBottom: { xs: 2, md: 0 },
                  marginBottom: { xs: 2, md: 0 },
                  height: { xs: "auto", md: "100vh" },
                  paddingRight: { xs: 0, md: "1rem" },
                }}
              >
                <Box>
                  {paymentOptions.map((option) => {
                    const isSelected = selectedId === option.id;

                    return (
                      <Card
                        key={option.id}
                        onClick={() => setSelectedId(option.id)}
                        sx={{
                          mb: 2,
                          borderRadius: 2,
                          border: isSelected
                            ? "1px solid #00a86b"
                            : "1px solid #e0e0e0",
                          position: "relative",
                          cursor: "pointer",
                        }}
                      >
                        {/* Green corner checkmark */}
                        {isSelected && (
                          <Box
                            sx={{
                              position: "absolute",
                              top: 0,
                              right: 0,
                              width: 0,
                              height: 0,
                              borderTop: "40px solid #00a86b",
                              borderLeft: "40px solid transparent",
                              zIndex: 1,
                            }}
                          >
                            <CheckIcon
                              sx={{
                                position: "absolute",
                                top: -32,
                                right: 4,
                                color: "white",
                                fontSize: 16,
                              }}
                            />
                          </Box>
                        )}

                        <CardContent sx={{ padding: "0px" }}>
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: "16px",
                              lineHeight: "120%",
                              letterSpacing: "0px",
                              p: isSelected ? 2 : 1,
                              mt: !isSelected && 1,
                              mb: !isSelected && -2,
                              ml: !isSelected && 2,
                              borderBottom: isSelected && "1px solid #E5E5E8",
                            }}
                          >
                            <span
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "4px",
                                alignItems: "center",
                              }}
                            >
                              <option.icon sx={{ color: "gray" }} />
                              {option.title}
                            </span>
                          </Typography>

                          {isSelected && (
                            <Box
                              sx={{
                                p: isSelected ? 2 : 1,
                              }}
                            >
                              <Box
                                sx={{
                                  textAlign: option.id === "qr" && "center",
                                }}
                              >
                                {option.qrImage && (
                                  <Box sx={{ mt: 2 }}>
                                    <img
                                      src={option.qrImage}
                                      alt="QR Code"
                                      style={{
                                        display: "block",
                                        margin: "0 auto",
                                      }}
                                    />
                                  </Box>
                                )}
                                <Typography
                                  sx={{
                                    mt: 1,
                                    fontWeight: "500",
                                    fontSize: "14px",
                                    lineHeight: "120%",
                                    letterSpacing: "0px",
                                  }}
                                >
                                  {option.description}
                                </Typography>
                              </Box>

                              {isSelected && option.id === "credit" && (
                                <Button
                                  onClick={() => setPaymentToggal(true)}
                                  variant="contained"
                                  sx={{
                                    mt: 2,
                                    background: "#6b21a8",
                                    "&:hover": {
                                      outline: "none",
                                      color: "#fff",
                                      backgroundColor: "#481AA3",
                                    },
                                  }}
                                >
                                  Pay with Stripe
                                </Button>
                              )}
                            </Box>
                          )}

                          {isSelected && option.id === "store" && (
                            <Box
                              sx={{
                                p: isSelected ? 2 : 1,
                              }}
                            >
                              <Typography
                                sx={{
                                  mt: -1,
                                  mb: 1,
                                  fontWeight: "500",
                                  fontSize: "14px",
                                  lineHeight: "120%",
                                  letterSpacing: "0px",
                                }}
                              >
                                {option.subTitle}
                              </Typography>
                              <TextField
                                fullWidth
                                size="small"
                                placeholder="Enter Confirmation code"
                                sx={{ mt: 2 }}
                              />
                              <Button
                                variant="contained"
                                sx={{
                                  mt: 2,
                                  background: "#6b21a8",
                                  width: "115px",
                                  height: "42px",
                                  "&:hover": {
                                    outline: "none",
                                    color: "#fff",
                                    backgroundColor: "#481AA3",
                                  },
                                }}
                              >
                                Confirm
                              </Button>
                            </Box>
                          )}
                        </CardContent>
                      </Card>
                    );
                  })}
                </Box>
              </Grid>

              {/* Right Box */}
              <Grid item xs={12} md={4}>
                <Box
                  sx={{
                    border: "1px solid #E5E5E8",
                    borderRadius: "12px",
                    // mt: 3,
                    p: 2,
                  }}
                >
                  {/* Header Section */}
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      alignItems: "center",
                      borderBottom: "1px solid #E5E5E8",
                      pb: 2,
                      fontWeight: "700",
                      fontSize: "24px",
                      lineHeight: "120%",
                      letterSpacing: "0px",
                    }}
                  >
                    Shipping Summary
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      mt: 1,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: "500",
                          fontSize: "15px",
                          lineHeight: "120%",
                          letterSpacing: "0px",
                        }}
                      >
                        Total
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: "700",
                          fontSize: "18px",
                          lineHeight: "120%",
                          letterSpacing: "0px",
                        }}
                      >
                        $245.00
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: "500",
                          fontSize: "15px",
                          lineHeight: "120%",
                          letterSpacing: "0px",
                        }}
                      >
                        Courier
                      </Typography>
                      <Typography
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <Box>
                          <img src={UPS} alt="image" width={24} />
                        </Box>

                        <Typography
                          sx={{
                            fontWeight: "700",
                            fontSize: "17px",
                            lineHeight: "120%",
                            letterSpacing: "0px",
                          }}
                        >
                          USPS International Exxpress
                        </Typography>
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: "500",
                          fontSize: "15px",
                          lineHeight: "120%",
                          letterSpacing: "0px",
                        }}
                      >
                        Weight
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: "700",
                          fontSize: "18px",
                          lineHeight: "120%",
                          letterSpacing: "0px",
                        }}
                      >
                        5.2 lbs
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: "500",
                          fontSize: "15px",
                          lineHeight: "120%",
                          letterSpacing: "0px",
                        }}
                      >
                        Dimensions
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: "700",
                          fontSize: "18px",
                          lineHeight: "120%",
                          letterSpacing: "0px",
                        }}
                      >
                        12”x 8”x 6”
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: "500",
                          fontSize: "15px",
                          lineHeight: "120%",
                          letterSpacing: "0px",
                        }}
                      >
                        Transit Time
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: "700",
                          fontSize: "18px",
                          lineHeight: "120%",
                          letterSpacing: "0px",
                        }}
                      >
                        2-3 Business days
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: "500",
                          fontSize: "15px",
                          lineHeight: "120%",
                          letterSpacing: "0px",
                        }}
                      >
                        Insurance
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: "700",
                          fontSize: "18px",
                          lineHeight: "120%",
                          letterSpacing: "0px",
                        }}
                      >
                        Included
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      )}
    </>
  );
}

export default CompleteYourPayment;
